var chunkMapping = {
	"0": [
		4793
	],
	"3": [
		4218,
		4505
	],
	"76": [
		5221
	],
	"158": [
		5303
	],
	"159": [
		5304
	],
	"162": [
		5307
	],
	"163": [
		5308
	],
	"164": [
		5309
	],
	"165": [
		5310
	],
	"166": [
		5311
	],
	"167": [
		5312
	],
	"168": [
		5313
	],
	"169": [
		5314
	],
	"170": [
		5315
	],
	"171": [
		5316
	],
	"172": [
		5317
	],
	"173": [
		5318
	],
	"174": [
		5319
	],
	"175": [
		5320
	],
	"176": [
		5321
	],
	"177": [
		5322
	],
	"178": [
		5323
	],
	"179": [
		5324
	]
};
var idToExternalAndNameMapping = {
	"4218": [
		"default",
		"./nuorder-components",
		3910
	],
	"4505": [
		"default",
		"./helios-components",
		3910
	],
	"4793": [
		"default",
		"./Containers",
		3820
	],
	"5221": [
		"default",
		"./OrderlessInvoices",
		3820
	],
	"5303": [
		"default",
		"./AsyncEventTracker",
		3820
	],
	"5304": [
		"default",
		"./HostWrapper",
		3820
	],
	"5307": [
		"default",
		"./CheckoutV3",
		3820
	],
	"5308": [
		"default",
		"./CheckoutConfirmation",
		3820
	],
	"5309": [
		"default",
		"./ContactCreditCards",
		3820
	],
	"5310": [
		"default",
		"./AuditDialog",
		3820
	],
	"5311": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3820
	],
	"5312": [
		"default",
		"./InvoiceDialog",
		3820
	],
	"5313": [
		"default",
		"./PaymentDueModal",
		3820
	],
	"5314": [
		"default",
		"./PaymentModal",
		3820
	],
	"5315": [
		"default",
		"./PaymentHistory",
		3820
	],
	"5316": [
		"default",
		"./PaymentConfigurations",
		3820
	],
	"5317": [
		"default",
		"./PaymentPreferences",
		3820
	],
	"5318": [
		"default",
		"./ManagePaymentProcessing",
		3820
	],
	"5319": [
		"default",
		"./MobilePaymentsWrapper",
		3820
	],
	"5320": [
		"default",
		"./Challenge",
		3820
	],
	"5321": [
		"default",
		"./ManagePaymentMethods",
		3820
	],
	"5322": [
		"default",
		"./LightspeedReports",
		3820
	],
	"5323": [
		"default",
		"./MarketingLandingPage",
		3820
	],
	"5324": [
		"default",
		"./ShippingPromotionsListContainer",
		3820
	]
};
var idToRemoteMap = {
	"4218": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3910
		}
	],
	"4505": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3910
		}
	],
	"4793": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5221": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5303": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5304": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5307": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5308": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5309": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5310": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5311": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5312": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5313": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5314": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5315": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5316": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5317": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5318": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5319": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5320": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5321": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5322": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5323": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	],
	"5324": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3820
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}